import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { showMessage } from 'app/store/fuse/messageSlice';
import { logoutUser, setUser } from 'app/store/userSlice';
import jwtService from './services/jwtService';
import { SUPER_ADMIN } from 'app/configs/constants';
import { setAdminUser } from 'app/store/adminSlice';
import { setAccessRules } from 'app/store/accessRulesSlice';
import {
  getDocuments,
} from "app/store/documentsSlice";

const AuthContext = React.createContext();

function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    jwtService.on('onAutoLogin', () => {
      // dispatch(showMessage({ message: '' }));

      /**
       * Sign in and retrieve user data with stored token
       */
      jwtService
        .signInWithToken()
        .then((response) => {
          success(response.user || {}, '', response || {});
        })
        .catch((error) => {
          pass(error.message);
        });
    });

    jwtService.on('onLogin', (user, userData = {}) => {
      success(user, '', userData);
    });

    jwtService.on('onLogout', () => {
      pass('Signed out');

      dispatch(logoutUser());
    });

    jwtService.on('onAutoLogout', (message) => {
      pass(message);

      dispatch(logoutUser());
    });

    jwtService.on('onNoAccessToken', () => {
      pass();
    });

    jwtService.init();

    function success(user, message, userData = {}) {
      // if (message) {
      //   dispatch(showMessage({ message }));
      // }

      Promise.all([
        dispatch(setUser(user)), dispatch(setAdminUser(user), dispatch(setAccessRules(userData)))
        // You can receive data in here before app initialization
      ]).then((values) => {
        setWaitAuthCheck(false);
        setIsAuthenticated(true);
        // dispatch(getDocuments([]))
      });
    }

    function pass(message) {
      // if (message) {
      //   dispatch(showMessage({ message }));
      // }

      setWaitAuthCheck(false);
      setIsAuthenticated(false);
    }
  }, [dispatch]);

  return waitAuthCheck ? (
    <FuseSplashScreen />
  ) : (
    <AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
